export class FeatureClass {
  DocumentLibrary: any;
  DailyActivity: any;
  AllOtherFile: any;
  PayrollVariance: any;
  PayrollAutoTransfer: boolean;
  UsernameAutoCreate: any;
  UsernameAutocreate: any;
  Enterprisesetting: string;
  ReviewStartDate: any;
  ReviewDate: string;
  Operatingstatmentreport: string;
  EHIDPermission: boolean;
  EmpCodeForADP: boolean;
  CheckPrintsplit: boolean;
  CheckfromEnterprise: boolean;
  PrintSeparatecheck: boolean;
  InvoiceApprovalorder: string;
  MinusOOO: boolean;
  DuplicateInvoiceNumber: string;
  InvoiceReadyforEntry: string;
  transactionsEHID: boolean;
  Automaticallycurrentaccountingperiod: boolean;
  DigitalSignature: boolean;
  TenantId: number;
  Message: string;
  TimeSheet: boolean = false;
  CheckBoxListArray: any[] = [];
  PTORequest: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/Classes/FeatureConfigurationClass.ts